<template lang="pug">
section.big-item-icon(:class="className")
  img(:src="src")
</template>

<script>
import iconTrain from './img/icon-big-train.svg';
import iconItem from './img/icon-big-item.svg';
import iconTicket from './img/icon-big-ticket.svg';
import iconTransfer from './img/icon-big-transfer.svg';
import iconAir from './img/icon-big-air.svg';

export default {
  name: 'BigIconCabinet',
  props: {
    type: {
      type: String,
      default: 'ticket',
      required: false,
    },
  },
  data: () => ({
    src: '',
    className: '',
  }),
  mounted() {
    this.load();
  },
  methods: {
    load() {
      switch (this.type) {
        case 'item':
          this.src = iconItem;
          this.className = 'def-item-icon__item';
          break;
        case 'train':
          this.src = iconTrain;
          this.className = 'def-item-icon__train';
          break;
        case 'air':
          this.src = iconAir;
          this.className = 'def-item-icon__air';
          break;
        case 'transfers':
          this.src = iconTransfer;
          this.className = 'def-item-icon__transfers';
          break;
        case 'ticket':
        default:
          this.src = iconTicket;
          this.className = 'def-item-icon__ticket';
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.big-item-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  &__ticket {
    background-color: rgb(133, 0, 255);
  }
  &__service {
    background-color: rgb(255, 153, 0);
  }
  &__train {
     background-color: rgb(0, 153, 255);
  }
  &__item {
    background-color: rgb(255, 153, 0);
  }
  &__air {
    background-color: rgb(0, 153, 255);
  }
}
</style>
